import notFoundIcon from '@/assets/emptyFeedIcon.svg'
import ErrorViewContainer from './ErrorViewContainer'

function CardNotFound({
  withBackButton
}: {
  withBackButton: boolean | undefined
}) {
  return (
    <ErrorViewContainer>
      <img
        src={notFoundIcon}
        width={449}
        height={357}
        alt="Feedpost not found or expired"
      />
      <p className="font-semibold text-center">Feedpost not found or expired</p>
      {withBackButton && (
        <a
          href="pulsate://backbtn"
          className="mt-9 pt-2 pb-2 pl-4 pr-4 w-full block rounded font-semibold border border-black text-center">
          Go to Main Page
        </a>
      )}
    </ErrorViewContainer>
  )
}

export default CardNotFound
